import { cva } from "class-variance-authority";

const RAIL_TAB_CLASSES =
  "self-stretch whitespace-nowrap px-3 duration-200 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring";

export const tabRailTabVariants = cva(
  "relative flex cursor-pointer items-center text-sm transition-colors outline-none",
  {
    variants: {
      variant: {
        default: "rounded-[calc(var(--radius)-2px)] px-3 py-1.5 font-medium",
        inline: RAIL_TAB_CLASSES,
        underline: RAIL_TAB_CLASSES,
      },
      selected: {
        true: "text-foreground",
        false: "text-muted-foreground hover:text-foreground",
      },
    },
    compoundVariants: [
      { variant: "default", selected: true, className: "bg-muted" },
      { variant: "default", selected: false, className: "hover:bg-muted" },
      { variant: ["inline", "underline"], selected: true, className: "font-medium" },
      { variant: ["inline", "underline"], selected: false, className: "font-normal" },
    ],
  }
);
